// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedRtcBotType {
  Interceptor: {"enum_constant":"Interceptor"};
  TeacherRecruitment: {"enum_constant":"TeacherRecruitment"};
  TestCall: {"enum_constant":"TestCall"};
}

export type RtcBotTypeId = keyof IParsedRtcBotType;
export type RtcBotTypeData = IParsedRtcBotType[RtcBotTypeId];
const data: RtcBotTypeData[] = [{"enum_constant":"Interceptor"},{"enum_constant":"TeacherRecruitment"},{"enum_constant":"TestCall"}];
export default data;
